import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromHardware from '@fc-store/reducers/hardware.reducer';

export const getHardwareState = createFeatureSelector<fromHardware.State>(
  fromHardware.hardwareFeatureKey,
);

export const getAllVehicleHardware = createSelector(
  getHardwareState,
  fromHardware.getAllHardware,
);

export const getHardwareById = (id: number) =>
  createSelector(getAllVehicleHardware, (hardware) =>
    hardware.find((h) => h.id === id),
  );
